define('report', function (require, exports, module) {
    var mLoadUrl = require('loadUrl');

    exports.rd = function (opt) {
        var oParams = {
                curl: location.href,
                rurl: document.referrer,
                serviceid: 10,
                mtag: '',
                // 商品skuid
                skuid: '',
                // 店铺id
                shopid: '',
                // command : 默认 pvlog 搜索属性 searchlog
                command: '',
                // 订单id
                dealid: '',
                callback: 'rdcb'
            },
            arrParams = [];

        for (var key in oParams) {
            var v = opt[key];
            if (v) {
                oParams[key] = v;
            }

            arrParams.push(key + '=' + encodeURIComponent(oParams[key]));
        }

        mLoadUrl.get({
            url: 'https://m.midea.cn/common/log/rd?' + arrParams.join('&')
        });
    };

    exports.itil = function (opt) {
        var oParams = {
                // itil的id
                id: '',
                // 1表示成功，2表示失败
                state: 1,
                callback: 'itilcb'
            },
            arrParams = [];

        for (var key in oParams) {
            var v = opt[key];
            if (v) {
                oParams[key] = v;
            }

            arrParams.push(key + '=' + encodeURIComponent(oParams[key]));
        }

        mLoadUrl.get({
            url: 'https://m.midea.cn/common/log/itil?' + arrParams.join('&')
        });
    }
});


// WEBPACK FOOTER //
// ./../common/js/report.js